import Pikaday from 'pikaday-time'
import moment from 'moment'
import 'pikaday-time/css/pikaday.css';

export default {
  initDisplay: function () {
    var Alpaca = $.alpaca

    // custom styles
    const styles = {}
    styles['button'] = 'btn btn-default'
    styles['smallButton'] = 'btn btn-default btn-sm'

    // custom callbacks
    const callbacks = {}

    callbacks['valid'] = function () {
      // valid fields remove the class 'has-error'
      $(this.getFieldEl()).removeClass('has-error')
    }
    callbacks['control'] = function () {
      // Todo ENHANCE THIS SHIT ASAP

      // controls get some special formatting

      // fieldEl
      const fieldEl = this.getFieldEl()

      // controlEl
      const controlEl = this.getControlEl()

      // all controls get the 'form-control' class injected
      $(fieldEl).find('input').addClass('form-control')
      $(fieldEl).find('textarea').addClass('form-control')
      $(fieldEl).find('select').addClass('form-control')
      // except for the following
      $(fieldEl).find('input[type=checkbox]').removeClass('form-control')
      $(fieldEl).find('input[type=file]').removeClass('form-control')
      $(fieldEl).find('input[type=radio]').removeClass('form-control')

      // special case for type == color, remove form-control
      if (this.inputType === 'color') {
        $(fieldEl).find('input').removeClass('form-control')
      }

      // any checkbox inputs get the 'checkbox' class on their checkbox
      $(fieldEl).find('input[type=checkbox]').parent().parent().addClass('checkbox')
      // any radio inputs get the 'radio' class on their radio
      $(fieldEl).find('input[type=radio]').parent().parent().addClass('radio')

      // if form has 'form-inline' class, then radio and checkbox labels get inline classes
      if ($(fieldEl).parents('form').hasClass('form-inline')) {
        // checkboxes
        $(fieldEl).find('input[type=checkbox]').parent().addClass('checkbox-inline')

        // radios
        $(fieldEl).find('input[type=radio]').parent().addClass('radio-inline')
      }

      // all control labels get class 'control-label'
      $(fieldEl).find('label.alpaca-control-label').addClass('control-label control-label-display')

      $(fieldEl).parent().parent().addClass('form-group')

      // if in horizontal mode, add a wrapper div (col-sm-9) and label gets (col-sm-3)
      if (this.view.horizontal) {
        $(fieldEl).find('label.alpaca-control-label').addClass('col-sm-2')

        const wrapper = $('<div></div>')
        wrapper.addClass('col-sm-10')

        $(controlEl).after(wrapper)
        wrapper.append(controlEl)

        $(fieldEl).append('<div style="clear:both"></div>')
      }
    }
    callbacks['container'] = function () {
      const containerEl = this.getContainerEl()

      if (this.view.horizontal) {
        $(containerEl).addClass('form-horizontal')
      }
    }

    callbacks['tableHeaderOptional'] = function (schema, options, domEl) { }

    Alpaca.registerView({
      'id': 'templ-display',
      'parent': 'web-display',
      'type': 'display',
      'ui': 'web',
      'title': 'Templ - Display',
      'displayReadonly': true,
      'callbacks': callbacks,
      'styles': styles,
      'templates': {},
      'horizontal': true
    })
  },
  initEdit: function () {
    var Alpaca = $.alpaca;

    // custom styles
    var styles = {};
    styles['button'] = 'btn btn-default';
    styles['smallButton'] = 'btn btn-default btn-sm';

    // custom callbacks
    var callbacks = {};
    callbacks['required'] = function () {
      var fieldEl = this.getFieldEl();

      // required fields get a little star in their label
      var label = $(fieldEl).find('label.alpaca-control-label');
      $('<span class="alpaca-icon-required"></span>').prependTo(label);
    };
    callbacks['invalid'] = function (hidden) {
      // if this is a control field, add class 'has-error'
      if (this.isControlField) {
        $(this.getFieldEl()).addClass('has-error');
      }
    };
    callbacks['valid'] = function () {
      // valid fields remove the class 'has-error'
      $(this.getFieldEl()).removeClass('has-error');
    };
    callbacks['control'] = function () {
      // Todo ENHANCE THIS SHIT ASAP

      // controls get some special formatting

      // fieldEl
      var fieldEl = this.getFieldEl();

      // controlEl
      var controlEl = this.getControlEl();

      // all controls get the 'form-control' class injected
      $(fieldEl).find('input').addClass('form-control');
      $(fieldEl).find('textarea').addClass('form-control');
      $(fieldEl).find('select').addClass('form-control');
      // except for the following
      $(fieldEl).find('input[type=checkbox]').removeClass('form-control');
      $(fieldEl).find('input[type=file]').removeClass('form-control');
      $(fieldEl).find('input[type=radio]').removeClass('form-control');

      // special case for type == color, remove form-control
      if (this.inputType === 'color') {
        $(fieldEl).find('input').removeClass('form-control');
      }

      // any checkbox inputs get the 'checkbox' class on their checkbox
      $(fieldEl).find('input[type=checkbox]').parent().parent().addClass('checkbox');
      // any radio inputs get the 'radio' class on their radio
      $(fieldEl).find('input[type=radio]').parent().parent().addClass('radio');

      // if form has 'form-inline' class, then radio and checkbox labels get inline classes
      if ($(fieldEl).parents('form').hasClass('form-inline')) {
        // checkboxes
        $(fieldEl).find('input[type=checkbox]').parent().addClass('checkbox-inline');

        // radios
        $(fieldEl).find('input[type=radio]').parent().addClass('radio-inline');
      }

      // all control labels get class 'control-label'
      $(fieldEl).find('label.alpaca-control-label').addClass('control-label');

      $(fieldEl).parent().parent().addClass('form-group');

      // if in horizontal mode, add a wrapper div (col-sm-9) and label gets (col-sm-3)
      if (this.view.horizontal) {
        $(fieldEl).find('label.alpaca-control-label').addClass('col-sm-2');

        var wrapper = $('<div></div>');
        wrapper.addClass('col-sm-10');

        $(controlEl).after(wrapper);
        wrapper.append(controlEl);

        $(fieldEl).append('<div style="clear:both;"></div>');
      }
    };
    callbacks['container'] = function () {
      var containerEl = this.getContainerEl();

      if (this.view.horizontal) {
        $(containerEl).addClass('form-horizontal');
      }
    };
    callbacks['enableButton'] = function (button) {
      $(button).removeAttr('disabled');
    };
    callbacks['disableButton'] = function (button) {
      $(button).attr('disabled', 'disabled');
    };
    callbacks['collapsible'] = function () {
      var fieldEl = this.getFieldEl();
      var legendEl = $(fieldEl).find('legend').first();
      var anchorEl = $('[data-toggle="collapse"]', legendEl);
      if ($(anchorEl).length > 0) {
        var containerEl = this.getContainerEl();

        // container id
        var id = $(containerEl).attr('id');
        if (!id) {
          id = Alpaca.generateId();
          $(containerEl).attr('id', id);
        }

        // set up container to be collapsible
        $(containerEl).addClass('collapse in');

        // set up legend anchor
        if (!$(anchorEl).attr('data-target')) {
          $(anchorEl).attr('data-target', '#' + id);
        }

        $(anchorEl)
          .mouseover(function (e) {
            $(this).css('cursor', 'pointer');
          })
      }
    };

    // table-control callbacks
    callbacks['tableHeaderRequired'] = function (schema, options, domEl) {
      // required fields get a little star in their label
      $('<span class="alpaca-icon-required"></span>').prependTo(domEl);
    };
    callbacks['tableHeaderOptional'] = function (schema, options, domEl) {
    };

    /* eslint-disable no-multi-str */
    var messageTemplate = ' \
 <script type="text/x-handlebars-template">\
    <div class="col-sm-10 pull-right field-validation-error error alpaca-message alpaca-message-{{{id}}}">\
    {{{message}}} \
    </div>\
</script>';

    /* eslint-disable no-multi-str */
    var formTemplate = '<script type="text/x-handlebars-template"> \
     <form role="form">\
    {{#formItems}}{{/formItems}}\
         <div class="form-group alpaca-form-buttons-container"> \
            <div class="col-lg-2"><span></span></div> \
            <div class="col-lg-10 text-left"> \
             {{#if options.buttons}} \
                {{#each options.buttons}} \
                    <button data-key="{{@key}}" type="{{type}}" {{#if id}}id="{{id}}"{{/if}} class="btn btn-primary alpaca-form-button alpaca-form-button-{{@key}} {{styles}}" {{#each value}}{{@key}}="{{this}}"{{/each}} {{#each attributes}} {{@key}}="{{this}}"{{/each}}>{{{value}}}</button> \
                {{/each}}\
            {{/if}}\
            </div>\
        </div>\
</form>\
</script>';

    Alpaca.registerView({
      'id': 'templ-edit',
      'parent': 'web-create',
      'type': 'edit',
      'ui': 'web',
      'title': 'Templ - Edit form',
      'displayReadonly': true,
      'callbacks': callbacks,
      'styles': styles,
      'templates': {
        'message': messageTemplate,
        'form': formTemplate
      },
      'horizontal': true
    });
  },
  initDateTime: function () {
    window.moment = moment
    // NOTE: this requires pikaday.js
    // NOTE: this requires moment.js

    var Alpaca = $.alpaca;

    Alpaca.Fields.DateField = Alpaca.Fields.TextField.extend(
      /**
       * @lends Alpaca.Fields.DateField.prototype
       */
      {
        /**
         * @see Alpaca.Fields.TextField#getFieldType
         */
        getFieldType: function () {
          return 'date';
        },

        getDefaultFormat: function () {
          return Alpaca.defaultDateFormat;
        },

        getDefaultExtraFormats: function () {
          return [];
        },

        /**
         * @see Alpaca.Fields.TextField#setup
         */
        setup: function () {
          var self = this;

          // default html5 input type = 'date';
          // this.inputType = 'date';

          this.base();

          if (!self.options.picker) {
            self.options.picker = {};
          }

          if (typeof (self.options.picker.useCurrent) === 'undefined') {
            self.options.picker.useCurrent = false;
          }

          // date format

          if (self.options.picker.format) {
            self.options.dateFormat = self.options.picker.format;
          }
          if (!self.options.dateFormat) {
            self.options.dateFormat = self.getDefaultFormat();
          }
          if (!self.options.picker.format) {
            self.options.picker.format = self.options.dateFormat;
          }

          if (!self.options.picker.locale) {
            self.options.picker.locale = Alpaca.defaultLocale;
          }

          if (!self.options.picker.dayViewHeaderFormat) {
            self.options.picker.dayViewHeaderFormat = 'MMMM YYYY';
          }

          // extra formats
          if (!self.options.picker.extraFormats) {
            var extraFormats = self.getDefaultExtraFormats();
            if (extraFormats) {
              self.options.picker.extraFormats = extraFormats;
            }
          }

          if (typeof (self.options.manualEntry) === 'undefined') {
            self.options.manualEntry = false;
          }
        },

        onKeyPress: function (e) {
          if (this.options.manualEntry) {
            e.preventDefault();
            e.stopImmediatePropagation();
          } else {
            this.base(e);
            return;
          }
        },

        onKeyDown: function (e) {
          if (this.options.manualEntry) {
            e.preventDefault();
            e.stopImmediatePropagation();
          } else {
            this.base(e);
            return;
          }
        },

        beforeRenderControl: function (model, callback) {
          this.field.css('position', 'relative');
          callback();
        },

        /**
         * @see Alpaca.Fields.TextField#afterRenderControl
         */
        afterRenderControl: function (model, callback) {
          var self = this;

          this.base(model, function () {
            if (self.view.type !== 'display') {
              if (Pikaday) {
                /* eslint-disable no-new, no-undef */
                self.picker = new Pikaday({
                  field: self.getControlEl()[0],
                  format: 'MM/DD/YYYY',
                  showTime: false
                });

                // with date-time picker, trigger change using plugin
                self.getFieldEl().on('dp.change', function (e) {
                  // we use a timeout here because we want this to run AFTER control click handlers
                  setTimeout(function () {
                    self.onChange(self, e);
                    self.triggerWithPropagation('change', e);
                  }, 250);
                });

                // set value if provided
                if (self.data) {
                  self.picker.setDate(self.data);
                }
              } else {
                alert('please include pikaday')
              }
            }

            callback();
          });
        },

        /**
         * Allows manual entry mode to be toggled on and off.
         *
         * @param manualEntry
         */
        setManualEntry: function (manualEntry) {
          this.options.manualEntry = manualEntry;
        },

        /**
         * Returns field value as a JavaScript Date.
         *
         * @returns {Date} Field value.
         */
        getDate: function () {
          var self = this;

          var date = null;
          try {
            if (self.picker) {
              date = (self.picker.date() ? self.picker.date()._d : null);
            } else {
              date = new Date(this.getValue());
            }
          } catch (e) {
            console.error(e);
          }

          return date;
        },

        /**
         * Returns field value as a JavaScript Date.
         *
         * @returns {Date} Field value.
         */
        date: function () {
          return this.getDate();
        },

        /**
         * @see Alpaca.Field#onChange
         */
        onChange: function (e) {
          this.base();

          this.refreshValidationState();
        },

        isAutoFocusable: function () {
          return false;
        },

        /**
         * @see Alpaca.Fields.TextField#handleValidate
         */
        handleValidate: function () {
          var baseStatus = this.base();

          var valInfo = this.validation;

          var status = this._validateDateFormat();
          valInfo['invalidDate'] = {
            'message': status ? '' : Alpaca.substituteTokens(this.getMessage('invalidDate'), [this.options.dateFormat]),
            'status': status
          };

          return baseStatus && valInfo['invalidDate']['status'];
        },

        /**
         * Validates date format.
         *
         * @returns {Boolean} True if it is a valid date, false otherwise.
         */
        _validateDateFormat: function () {
          var self = this;

          var isValid = true;

          if (self.options.dateFormat) {
            var value = self.getValue();
            if (value || self.isRequired()) {
              // collect all formats
              var dateFormats = [];
              dateFormats.push(self.options.dateFormat);
              if (self.options.picker && self.options.picker.extraFormats) {
                for (var i = 0; i < self.options.picker.extraFormats.length; i++) {
                  dateFormats.push(self.options.picker.extraFormats[i]);
                }
              }

              for (var y = 0; y < dateFormats.length; y++) {
                isValid = isValid || Alpaca.moment(value, self.options.dateFormat, true).isValid();
              }
            }
          }

          return isValid;
        },

        /**
         * @see Alpaca.Fields.TextField#setValue
         */
        setValue: function (value) {
          var self = this;

          this.base(value);

          if (this.picker) {
            if (Alpaca.moment(value, self.options.dateFormat, true).isValid()) {
              this.picker.setDate(value);
            }
          }
        },

        destroy: function () {
          this.base();

          this.picker = null;
        },

        /* builder_helpers */

        /**
         * @see Alpaca.Fields.TextField#getTitle
         */
        getTitle: function () {
          return 'Date Field';
        },

        /**
         * @see Alpaca.Fields.TextField#getDescription
         */
        getDescription: function () {
          return 'Date Field';
        },

        /**
         * @private
         * @see Alpaca.Fields.TextField#getSchemaOfSchema
         */
        getSchemaOfSchema: function () {
          return Alpaca.merge(this.base(), {
            'properties': {
              'format': {
                'title': 'Format',
                'description': 'Property data format',
                'type': 'string',
                'default': 'date',
                'enum': ['date'],
                'readonly': true
              }
            }
          });
        },

        /**
         * @private
         * @see Alpaca.Fields.TextField#getOptionsForSchema
         */
        getOptionsForSchema: function () {
          return Alpaca.merge(this.base(), {
            'fields': {
              'format': {
                'type': 'text'
              }
            }
          });
        },

        /**
         * @private
         * @see Alpaca.Fields.TextField#getSchemaOfOptions
         */
        getSchemaOfOptions: function () {
          return Alpaca.merge(this.base(), {
            'properties': {
              'dateFormat': {
                'title': 'Date Format',
                'description': 'Date format (using moment.js format)',
                'type': 'string'
              },
              'picker': {
                'title': 'DatetimePicker options',
                'description': 'Options that are supported by the <a href="http://eonasdan.github.io/bootstrap-datetimepicker/">Bootstrap DateTime Picker</a>.',
                'type': 'any'
              }
            }
          });
        },

        /**
         * @private
         * @see Alpaca.Fields.TextField#getOptionsForOptions
         */
        getOptionsForOptions: function () {
          return Alpaca.merge(this.base(), {
            'fields': {
              'dateFormat': {
                'type': 'text'
              },
              'picker': {
                'type': 'any'
              }
            }
          });
        }

        /* end_builder_helpers */
      });

    Alpaca.registerMessages({
      'invalidDate': 'Invalid date for format {0}'
    });
    Alpaca.registerFieldClass('date', Alpaca.Fields.DateField);
    Alpaca.registerDefaultFormatFieldMapping('date', 'date');
  },
  init: function (listener, handler) {
    this.initDisplay()
    this.initEdit()
    this.initDateTime()
  }
}



// WEBPACK FOOTER //
// ./scripts/modules/alpaca-register.js